import { Paperclip, Send } from "lucide-react";
import {
  AI_CHAT_DISCLAIMER,
  AI_CHAT_EMPTY_DISCLAIMER,
  AI_CHAT_EMPTY_INPUT_PLACEHOLDER,
  AI_CHAT_INPUT_PLACEHOLDER,
} from "../constants";

type Props = {
  value: string;
  isEmptyState?: boolean;
  disabled?: boolean;
  onChange: (value: string) => void;
  onSend: () => void;
};

export function AIChatComposer({
  value,
  isEmptyState,
  disabled,
  onChange,
  onSend,
}: Props) {
  return (
    <div className="mx-auto w-full max-w-3xl px-4 pb-2 md:px-8">
      <div className="flex items-center gap-2 rounded-full border border-[#E5E7EB] bg-white px-3 py-1.5 shadow-sm">
        <button
          type="button"
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full text-[#9CA3AF] hover:bg-[#F3F4F6]"
          aria-label="Attach file"
        >
          <Paperclip className="h-4 w-4" />
        </button>
        <input
          value={value}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === "Enter" && !e.shiftKey) {
              e.preventDefault();
              onSend();
            }
          }}
          placeholder={
            isEmptyState
              ? AI_CHAT_EMPTY_INPUT_PLACEHOLDER
              : AI_CHAT_INPUT_PLACEHOLDER
          }
          className="h-10 min-w-0 flex-1 border-0 bg-transparent text-sm text-[#111827] outline-none placeholder:text-[#9CA3AF]"
          disabled={disabled}
        />
        <button
          type="button"
          onClick={onSend}
          disabled={disabled || !value.trim()}
          className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-primary text-white hover:bg-primary/90 disabled:opacity-40"
          aria-label="Send"
        >
          <Send className="h-4 w-4" />
        </button>
      </div>
      <p className="mt-2 text-center text-[11px] text-[#9CA3AF]">
        {isEmptyState ? AI_CHAT_EMPTY_DISCLAIMER : AI_CHAT_DISCLAIMER}
      </p>
    </div>
  );
}
